<footer>
  <div class="container">
    <div class="footer-column">
      <h2>{{'sidebar.title'|transloco}}</h2>
      <p>{{'footer.description'|transloco}}</p>
    </div>

    <div class="footer-column">
      <h3>{{'footer.find-photographer.title'|transloco}}</h3>
      <a href="/?city=paris">{{'footer.find-photographer.paris'|transloco}}</a>
      <a href="/?tags=wedding">{{'footer.find-photographer.wedding'|transloco}}</a>
      <a href="/?tags=couple">{{'footer.find-photographer.couple'|transloco}}</a>
      <a href="/?tags=professional">{{'footer.find-photographer.pro'|transloco}}</a>
      <a href="/gift-card">{{'footer.find-photographer.gift-card'|transloco}}</a>
    </div>

    <div class="footer-column">
      <h3>{{'footer.for-photographers.title'|transloco}}</h3>
      <a href="/manage">{{'footer.for-photographers.manage'|transloco}}</a>
      <a href="/blog">{{'footer.for-photographers.learn-more'|transloco}}</a>
    </div>

    <div class="footer-column">
      <h3>{{'footer.resources.title'|transloco}}</h3>
      <a href="https://www.instagram.com/shutterflow_io/" target="_blank" class="footer-column__link-social">
        <i class="fa-brands fa-instagram"></i>
      </a>
      <a href="https://www.linkedin.com/company/shutterflow-io" target="_blank" class="footer-column__link-social">
        <i class="fa-brands fa-linkedin"></i>
      </a>
      <a href="https://www.threads.com/@louist.dupont" target="_blank" class="footer-column__link-social">
        <i class="fa-brands fa-square-threads"></i>
      </a>
    </div>
  </div>
</footer>
